module.exports = "pegasus/assets/blocks/column-1-basic.png";